<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-01">“<i>We can no longer afford an obsolete society of obsolete people</i>.”</p>
<p class="fm-02">—P<span class="smallcaps">RESIDENT</span> H<span class="smallcaps">AROLD</span> K. M<span class="smallcaps">ORSE</span></p>
<p class="fm-02"><i>Second Inaugural Address</i></p>
<p class="fm-02"><i>January 20, 1988</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frantmatter01.vue?180498ff